export const ElementType = {
  CENTER_WORD_VOICE_TEST: 803, // 语音测试-中心词
  CENTER_WORD_PARARAGPH: 820, // 段提问-中心词
  CENTER_WORD_STORY: 822, // 扩听故事-中心词
  ABC: 821, // ABC讲解
  FOLLOW_READ: 815, // 跟读
  BIG_FOLLOW_READ: 824, // 大情景段跟读
}

export const AppVersion = {
  fixRecordChannel: {
    IOS: '1.1.0',
    Android: '1.0.7',
  },
}

/**
 * 测评元素
 */
export const TEST_ELEMENT = [
  802, 816, 825, 817, 828, 831, 819, 822, 821, 803, 820, 839, 840,
]

// 文武功类型
export const CourseType = {
  WEN: 101,
  WU: 100,
}

export const CourseTypeMap = {
  [CourseType.WEN]: '文功',
  [CourseType.WU]: '武功',
}

// 元素标题映射
export const LessonTitleMap = {
  800: '视频',
  802: 'AB判定',
  803: '口语表达',
  822: '口语表达',
  840: '理解',
}
